/**
 * Determines whether a preferred time filter has been selected (e.g., 08:00 - 12:00).
 *
 * This is used to control whether an alert is shown in the calendar view,
 * notifying users that they are filtering time slots by their preferred
 * time period but there are no time slots available.
 *
 * @param {Record<string, boolean>} timeFilters - An object where the keys represent time periods, and the values represent whether the user has selected the time filter.
 */ const isPreferredTimeFilterActive = (timeFilters)=>Object.values(timeFilters).some((value)=>value
    )
;

export { isPreferredTimeFilterActive };
//# sourceMappingURL=is-preferred-time-filter-active.js.map
